/* Product page behaviour; every price comes from Liquid selling plans, never computed (D-0443) */
(() => {
  const money = (cents, sample) => {
    const n = (cents / 100).toFixed(2);
    if (!sample) return '$' + n;
    const symbol = (sample.match(/^[^\d]*/) || [''])[0];
    const tail = (sample.match(/[^\d.,]*$/) || [''])[0];
    return symbol + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + tail;
  };

  /* Removes Recharge widget: its duplicate selling_plan field bills one-time buyers (D-0445) */
  const stripRecharge = (form) => {
    let removed = 0;
    form.querySelectorAll('.rc-container-wrapper, .rc_container_wrapper, .rc-widget, .rc_widget').forEach((el) => {
      el.remove();
      removed++;
    });
    form.querySelectorAll('[name="selling_plan"]').forEach((el) => {
      if (!el.classList.contains('drb-pdp__radio')) el.remove();
    });
    return removed;
  };

  document.querySelectorAll('[data-drb-pdp]').forEach((root) => {
    if (root.dataset.drbReady === 'true') return;
    root.dataset.drbReady = 'true';

    const form = root.querySelector('#drb-pdp-form') || root.querySelector('form[action*="/cart/add"]');
    if (form) {
      stripRecharge(form);
      new MutationObserver(() => stripRecharge(form)).observe(form, { childList: true, subtree: true });
    }

    const slides = Array.from(root.querySelectorAll('[data-drb-pdp-slide]'));
    /* Index from the attribute: a lead image override shifts array positions (D-0448) */
    const picks = Array.from(root.querySelectorAll('[data-drb-pdp-thumb]'));
    const pickIndex = (el) => parseInt(el.dataset.drbPdpThumb, 10);
    const stage = root.querySelector('.drb-pdp__stage');
    let index = 0;

    const wrap = (n) => ((n % slides.length) + slides.length) % slides.length;

    const showSlide = (n) => {
      if (!slides.length) return;
      index = wrap(n);
      slides.forEach((s, i) => {
        s.hidden = i !== index;
      });
      picks.forEach((el) => el.setAttribute('aria-current', pickIndex(el) === index ? 'true' : 'false'));
    };

    /* Warms hidden slides only after load and when idle, to protect the LCP (D-0450) */
    const warm = (n) => {
      const s = slides[wrap(n)];
      const img = s && s.querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
    };
    const saveData = !!(navigator.connection && navigator.connection.saveData);
    if (slides.length > 1 && !saveData) {
      const warmAll = () => slides.forEach((s, i) => warm(i));
      const whenIdle = () => ('requestIdleCallback' in window ? requestIdleCallback(warmAll, { timeout: 4000 }) : setTimeout(warmAll, 1500));
      if (document.readyState === 'complete') whenIdle();
      else window.addEventListener('load', whenIdle, { once: true });
    }

    picks.forEach((el) => {
      el.addEventListener('pointerenter', () => warm(pickIndex(el)), { passive: true });
      el.addEventListener('touchstart', () => warm(pickIndex(el)), { passive: true });
      el.addEventListener('click', () => { showSlide(pickIndex(el)); warm(pickIndex(el) + 1); });
    });

    if (stage && slides.length > 1) {
      const INTENT = 8;
      const COMMIT = 40;
      const FLICK = 14;
      const TRAVEL = 120;
      const PEEK = 46;
      let g = null;

      stage.classList.add('is-gestured');

      const release = () => {
        stage.classList.remove('is-dragging');
        stage.style.setProperty('--drb-pdp-peek', '0px');
      };

      stage.addEventListener('pointerdown', (event) => {
        if (event.button && event.button !== 0) return;
        if (event.target.closest('a, button')) return;
        g = {
          x: event.clientX,
          y: event.clientY,
          id: event.pointerId,
          axis: null,
          touch: event.pointerType === 'touch',
          dx: 0,
          t0: event.timeStamp,
          t: event.timeStamp,
        };
      });

      stage.addEventListener('pointermove', (event) => {
        if (!g || event.pointerId !== g.id) return;

        const dx = event.clientX - g.x;
        const dy = event.clientY - g.y;

        if (!g.axis) {
          if (Math.abs(dx) < INTENT && Math.abs(dy) < INTENT) return;
          g.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (g.axis === 'y') {
            g = null;
            return;
          }
          stage.classList.add('is-dragging');

          /* Capture only after the axis is known, so a mouse release outside ends the drag (D-0456) */
          if (stage.setPointerCapture) {
            try {
              stage.setPointerCapture(event.pointerId);
            } catch (e) {
            }
          }
        }

        g.dx = dx;
        g.t = event.timeStamp;

        const p = Math.min(Math.abs(dx) / TRAVEL, 1) * PEEK;
        stage.style.setProperty('--drb-pdp-peek', (dx < 0 ? -p : p) + 'px');
      });

      /* Commit cancelled gestures past threshold: iOS edge swipes fire pointercancel (D-0458) */
      stage.addEventListener('pointercancel', () => {
        if (!g) return;
        const commit = g.axis === 'x' && Math.abs(g.dx) >= COMMIT;
        const dir = g.dx < 0 ? 1 : -1;
        g = null;
        if (commit) showSlide(index + dir);
        release();
      });

      stage.addEventListener('pointerup', (event) => {
        if (!g || event.pointerId !== g.id) return;

        const dx = event.clientX - g.x;
        const dy = event.clientY - g.y;
        const dragged = g.axis === 'x';
        const g_t0 = g.t0;
        g = null;

        if (dragged) {
          const dt = event.timeStamp - g_t0;
          const speed = dt > 0 ? Math.abs(dx) / dt : 0;
          const far = Math.abs(dx) >= COMMIT;
          const fast = speed >= 0.35 && Math.abs(dx) >= FLICK;
          if (far || fast) showSlide(index + (dx < 0 ? 1 : -1));
          release();
          return;
        }

        release();

        if (Math.abs(dx) < 10 && Math.abs(dy) < 10) {
          const rect = stage.getBoundingClientRect();
          showSlide(index + (event.clientX - rect.left > rect.width / 2 ? 1 : -1));
        }
      });
    }

    const options = Array.from(root.querySelectorAll('[data-drb-pdp-option]'));
    const atcPrice = root.querySelector('[data-drb-pdp-atcprice]');

    const subCard = root.querySelector('.drb-pdp__option--sub');
    const subPriceEl = subCard ? subCard.querySelector('.drb-pdp__prices b') : null;
    const subPerEl = subCard ? subCard.querySelector('.drb-pdp__per') : null;

    const sampleEl = subPriceEl || atcPrice;
    const priceSample = sampleEl ? sampleEl.textContent.trim() : '';

    const stickyPrice = root.querySelector('[data-drb-pdp-stickyprice]');
    const setAtc = (cents) => {
      if (!Number.isFinite(cents)) return;
      const text = money(cents, priceSample);
      if (atcPrice) atcPrice.textContent = text;
      if (stickyPrice) stickyPrice.textContent = text;
    };

    const selectOption = (option) => {
      options.forEach((o) => o.classList.toggle('is-selected', o === option));
      const radio = option.querySelector('.drb-pdp__radio');
      if (!radio) return;
      radio.checked = true;
      setAtc(parseInt(radio.dataset.drbPdpPrice, 10));
    };

    options.forEach((option) => {
      const radio = option.querySelector('.drb-pdp__radio');
      if (!radio) return;
      radio.addEventListener('change', () => {
        if (radio.checked) selectOption(option);
      });
    });

    const freqButtons = Array.from(root.querySelectorAll('[data-drb-pdp-plan]'));
    const subRadio = subCard ? subCard.querySelector('.drb-pdp__radio') : null;
    const days = parseInt(root.dataset.drbPdpDays, 10);

    freqButtons.forEach((button) => {
      button.addEventListener('click', () => {
        freqButtons.forEach((b) => {
          const on = b === button;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        const planId = button.dataset.drbPdpPlan;
        const cents = parseInt(button.dataset.drbPdpPlanprice, 10);

        if (subRadio) {
          subRadio.value = planId;
          subRadio.dataset.drbPdpPrice = String(cents);
        }

        if (subPriceEl && Number.isFinite(cents)) {
          subPriceEl.textContent = money(cents, subPriceEl.textContent.trim());
        }

        if (subPerEl && Number.isFinite(cents) && Number.isFinite(days) && days > 0) {
          const rest = subPerEl.textContent.replace(/^\s*\S+\s*/, '');
          subPerEl.textContent = money(Math.round(cents / days), priceSample) + ' ' + rest;
        }

        if (subCard) selectOption(subCard);
      });
    });

    const checked = options.find((o) => {
      const r = o.querySelector('.drb-pdp__radio');
      return r && r.checked;
    });
    if (checked) selectOption(checked);
  });
})();

/* Watches the real button; the bar button stays tabindex -1 until shown (D-0470) */
(function drbPdpSticky() {
  const init = () => {
    document.querySelectorAll('[data-drb-pdp]').forEach((root) => {
      const bar = root.querySelector('[data-drb-pdp-sticky]');
      const atc = root.querySelector('[data-drb-pdp-atc]');
      const btn = root.querySelector('[data-drb-pdp-stickybtn]');
      if (!bar || !atc) return;

      const show = (on) => {
        bar.classList.toggle('is-in', on);
        if (btn) btn.tabIndex = on ? 0 : -1;
      };

      if (!('IntersectionObserver' in window)) return;

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            const scrolledPast = e.boundingClientRect.top < 0;
            show(!e.isIntersecting && scrolledPast);
          });
        },
        { threshold: 0, rootMargin: '0px 0px -12px 0px' }
      );
      io.observe(atc);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
